import Vue from 'vue';
export default new Vue();

export const FORM_EVENTS_TYPE = {
    /**
     * 是否打开弹窗，true-打开 false-关闭
     */
    IS_OPEN_PICKER: 'is-open-picker',
    /**
     * 埋点上报
     */
    SEND_FORM_LOG: 'send-log',
    /**
     * OCR识别
     */
    OCR_RECOGNITION: 'ocr-recognition',
    /**
     * 选择器值变化
     */
    PICKER_VALUE_CHANGE: 'PICKER_VALUE_CHANGE',
};
